import {
  LanguageId,
  useArticleTranslationUnpublishMutation,
} from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<
  typeof useArticleTranslationUnpublishMutation
>[0];
type MutationReturnValue = ReturnType<MutationFunction>;

export type TranslationUnpublishFn = () => MutationReturnValue;

type UseArticleTranslationUnpublishReturnValue = [
  TranslationUnpublishFn,
  ReturnType<typeof useArticleTranslationUnpublishMutation>[1],
];

type UseArticleTranslationUnpublishOptions = {
  articleId: string;
  languageId: LanguageId;
};

export function useArticleTranslationUnpublish({
  articleId,
  languageId,
}: UseArticleTranslationUnpublishOptions): UseArticleTranslationUnpublishReturnValue {
  const [unpublishFn, mutationResult] =
    useArticleTranslationUnpublishMutation();

  const unpublish: TranslationUnpublishFn = async () => {
    return unpublishFn({
      variables: {
        articleId,
        languageId,
      },
      refetchQueries: ['ArticleTranslation'],
    }).then((args) => {
      ampli.knowledgeArticleUnpublished({ articleId });
      return args;
    });
  };

  return [unpublish, mutationResult];
}
